import React from 'react';
import './style.css';
import Title from '../component/Title'
const HomePage = () => {
    return (
        <div id="about">
            <Title name="About" />
            <div className="content">
                <img className="profilePic" alt="standing near cliff" src={require('../assets/me.jpg')} />
                <div className="about-text">
                    <h2>About Me</h2>
                    <p>My interest in programming began during my college years when I studied computing. I was fascinated by the possibility and power of programming. As I learned more about programming, my passion for the industry grew, and I decided to pursue a BEng in Software Engineering at Sheffield Hallam University. Since then, I have enjoyed learning about new technologies and frameworks, keeping myself updated with the industry, which continues to inspire me to create new things.</p>
                    <p>Aside from programming, I also have a keen interest in photography, editing, and sports. I find that these hobbies provide me with a creative outlet and allow me to approach problem-solving from a different perspective.</p>

                </div>

            </div>
        </div>
    )
}
export default HomePage;